import React, { createContext } from 'react'

import { AddToCartFuncSync, useAddToCart } from '@Domains/Cart/Hooks/useAddToCart'
import { AddToCartProductInput } from '@Generated/graphql'

export interface BuyContextValue {
  handleAddToCart: (e?: React.MouseEvent) => void
  handlePromptSubmit: AddToCartFuncSync
  isDisabled: boolean
  isLoading: boolean
  prompts: ReturnType<typeof useAddToCart>[1]['prompts']
  reset: () => void
  variables: AddToCartProductInput[] | null
  withoutSuccessPrompt?: boolean
}

export const BuyContext = createContext<BuyContextValue | null>(null)
